import styled from "styled-components";
import COLORS from "../../Theme/Colors";

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  li {
    list-style-type: none;
  }
`;

export const Icon = styled.div`
  color: ${COLORS.white};
  font-size: 22px;

  &:hover {
    color: ${COLORS.darkgray};
  }
`;
